import { useMemo } from 'react';
import { paginate } from '../../../shared/utils/paginate';

interface IUsePagination<T> {
	list: T[];
	pageNumber: number;
	itemsPerPage: number;
}

export const usePagination = <T>({
	list,
	pageNumber,
	itemsPerPage,
}: IUsePagination<T>) => {
	const { currentPageItems, numberOfPages } = useMemo(() => {
		const { numberOfPages: totalPages, getPageByNumber } = paginate(
			list,
			itemsPerPage,
		);

		const isPageNumberOutOfRange: boolean =
			Number.isNaN(pageNumber) || pageNumber < 1 || pageNumber > totalPages;

		const items: T[] =
			isPageNumberOutOfRange || !list ? [] : getPageByNumber(pageNumber);

		return {
			currentPageItems: items,
			numberOfPages: totalPages,
		};
	}, [list, pageNumber]);

	return {
		currentPageItems,
		numberOfPages,
	};
};
